import styled from 'styled-components';

export const Container = styled.div`
    display: flex;

    flex-direction: column;

    align-items: center;
    justify-content: center;
    
    width: 100%;
    margin: 2rem 0rem 4rem 0rem;
`;

export const Circle = styled.div`
    display: flex;
    flex-direction: column; 

    align-items: center;
    justify-content: center;

    opacity: 90%;
    border-radius: 50%;

    h1 {
        margin: 0;
    }

    .clock {
        margin-top: 1rem;
        color: black;
    }
`;